import { BookOpenCheckIcon, ClipboardCheckIcon, FlaskConicalIcon, FolderOpenIcon, MapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Meteorology & Atmospheric Science Classroom Activities',
    description:
      '150 ready-to-use activity ideas covering atmospheric fundamentals, thermodynamics, clouds, precipitation, winds, air masses, weather systems, severe weather, observations, forecasting, and climate. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Complete Meteorology Assessment Toolkit',
    description:
      'Diagnostic assessments, progress activities, quizzes, tests, applied questions, assessment strategies, rubrics, scoring criteria, and guidance for evaluating student learning in meteorology.',
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Weather & Atmospheric Science Case Studies',
    description:
      'One hundred written real-world weather and atmospheric cases where students analyze evidence, interpret conditions, answer critical-thinking questions, and develop reasoned conclusions. Covers weather systems, severe events, forecasting challenges, and climate phenomena.',
    benefit: 'Your students learn by analyzing authentic atmospheric scenarios.',
    value: 'USD 14',
    icon: MapIcon,
  },
  {
    number: '04',
    title: '100 Meteorology Experiments, Investigations & Classroom Challenges',
    description:
      '100 experiments, investigations, and practical challenges that allow students to explore atmospheric concepts through observation, analysis, prediction, and hands-on inquiry. Covers temperature, pressure, humidity, clouds, winds, and weather systems.',
    benefit: 'Your students learn by doing atmospheric science.',
    value: 'USD 14',
    icon: FlaskConicalIcon,
  },
  {
    number: '05',
    title: 'Meteorology Lesson Planning & Teaching Resource Library',
    description:
      'A practical teaching resource with lesson-planning frameworks, classroom sequences, review activities, quizzes, projects, assessment ideas, and adaptable teaching strategies designed to simplify preparation and classroom implementation.',
    benefit: 'Everything you need to plan and teach a complete meteorology course.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
